import type { NavSection } from '@pazportal/ui';

// Ink, matching the customer portal and admin (paznetworks.com header).
export const PORTAL_COLOR = '#1F1E26';
export const PORTAL_NAME = 'PazNetworks, Inc.';
export const PORTAL_SUBTITLE = 'On-Site Portal';

export const navSections: NavSection[] = [
  {
    label: 'Project',
    items: [
      { label: 'Overview', href: '/dashboard' },
      { label: 'Pre-trip Brief', href: '/brief' },
      { label: 'Project Detail', href: '/project' },
      { label: 'Daily Report', href: '/daily-report' },
    ],
  },
  {
    label: 'Documentation',
    items: [
      { label: 'Network', href: '/network' },
      { label: 'Inventory', href: '/inventory' },
      { label: 'Lifecycle', href: '/lifecycle' },
    ],
  },
  {
    label: 'Intelligence',
    items: [
      { label: 'Site Intel', href: '/intel' },
    ],
  },
];

export interface MobileNavItem {
  label: string;
  href: string;
  /** SVG path data (24x24 viewBox, stroked). */
  icon: string;
}

/**
 * Bottom navigation for phones. Four primary destinations fit at 375px with
 * legible 11px labels; the remaining routes live behind "More" so every
 * route stays reachable without the desktop sidebar.
 */
export const MOBILE_NAV_PRIMARY: MobileNavItem[] = [
  {
    label: 'Overview',
    href: '/dashboard',
    icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
  },
  {
    label: 'Daily',
    href: '/daily-report',
    icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
  },
  {
    label: 'Network',
    href: '/network',
    icon: 'M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01',
  },
  {
    label: 'Inventory',
    href: '/inventory',
    icon: 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10',
  },
];

export const MOBILE_NAV_MORE: MobileNavItem[] = [
  {
    label: 'Pre-trip Brief',
    href: '/brief',
    icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4',
  },
  {
    label: 'Project Detail',
    href: '/project',
    icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2',
  },
  {
    label: 'Site Intel',
    href: '/intel',
    icon: 'M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z',
  },
  {
    label: 'Hardware Lifecycle',
    href: '/lifecycle',
    icon: 'M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15',
  },
];

export const MOBILE_NAV_MORE_ICON = 'M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z';
